import { useTranslation } from '@kostbar/i18n'
import type { Product } from '@/api/types'
import { Badge } from '@/components/ui/badge'

/**
 * "Gericht" for a product with its own stock usage list, "Variante" for a variant
 * (CHG-2026-09-stock-usage-and-price-twins, 10.9). Renders nothing for an ordinary product.
 */
export function ProductKindBadge({
  product,
}: {
  product: Pick<Product, 'isDish' | 'variantSourceSku'>
}) {
  const { t: tProducts } = useTranslation('products')
  if (product.variantSourceSku) {
    return <Badge variant="secondary">{tProducts('kind.variant')}</Badge>
  }
  if (product.isDish) {
    return <Badge variant="secondary">{tProducts('kind.dish')}</Badge>
  }
  return null
}
